import React from 'react'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { collegeColumns } from '../../Data/CollegeManagement/CollegeListData'
import { getAllData, deleteIdData } from '../../lib/collegerank'
import { useDataManagement } from '../../Hooks/useDataManagement'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminCollegeList = () => {
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const { data: colleges, loading, searchQuery, setSearchQuery, handleDelete } = useDataManagement(getAllData, deleteIdData)

	const sortedColleges = React.useMemo(() => {
		return [...colleges].sort((a, b) => {
			const nameA = a.collegename ? a.collegename : ''
			const nameB = b.collegename ? b.collegename : ''
			return nameA.localeCompare(nameB)
		})
	}, [colleges])

	return (
		<DataManagementGrid
			title="Desired Colleges"
			subTitle="Manage all desired colleges in the system"
			breadcrumbTitle="College Management"
			breadcrumbMainTitle="College Management"
			columns={(layout, role) => collegeColumns(layout, role)}
			data={sortedColleges}
			loading={loading}
			searchQuery={searchQuery}
			setSearchQuery={setSearchQuery}
			searchPlaceholder="Search by college name..."
			createButtonText="Create New College"
			createButtonLink={`${process.env.PUBLIC_URL}/${role}/colleges/create/${layout}`}
			onDelete={handleDelete}
			searchFields={['collegename']}
			noDataMessage="No colleges found"
		/>
	)
}

export { AdminCollegeList }
